import { z } from 'zod';
import { Locale, SubscriptionStatus, TenantStatus } from '../enums.js';

const slug = z
  .string()
  .min(2)
  .max(40)
  .regex(/^[a-z0-9][a-z0-9-]*$/);

export const CreateTenantSchema = z.object({
  slug,
  nameAr: z.string().min(2).max(120),
  nameEn: z.string().min(2).max(120).optional(),
  timezone: z.string().default('Africa/Cairo'),
  locale: z.enum(Locale).default('AR'),
  planCode: z.string().min(1),
  trialDays: z.number().int().min(0).max(365).default(14),
  /** First tenant admin */
  admin: z.object({
    email: z.string().email().transform((s) => s.trim().toLowerCase()),
    fullName: z.string().min(2).max(120),
    password: z.string().min(8).max(128),
  }),
});
export type CreateTenant = z.infer<typeof CreateTenantSchema>;

export const UpdateTenantSchema = z.object({
  nameAr: z.string().min(2).max(120).optional(),
  nameEn: z.string().min(2).max(120).nullable().optional(),
  timezone: z.string().optional(),
  locale: z.enum(Locale).optional(),
  status: z.enum(TenantStatus).optional(),
});
export type UpdateTenant = z.infer<typeof UpdateTenantSchema>;

export const UpsertPlanSchema = z.object({
  code: z.string().min(2).max(40).regex(/^[a-z0-9-]+$/),
  nameAr: z.string().min(2).max(80),
  nameEn: z.string().min(2).max(80),
  maxVehicles: z.number().int().min(1),
  maxDevices: z.number().int().min(0),
  maxUsers: z.number().int().min(1),
  positionRetentionMonths: z.number().int().min(1).max(60).default(12),
  priceMonthlyEgp: z.number().min(0),
  features: z.record(z.boolean()).default({}),
  isActive: z.boolean().default(true),
});
export type UpsertPlan = z.infer<typeof UpsertPlanSchema>;

export const CreateSubscriptionSchema = z.object({
  planCode: z.string().min(1),
  status: z.enum(SubscriptionStatus).default('ACTIVE'),
  startsAt: z.string().datetime({ offset: true }).optional(),
  endsAt: z.string().datetime({ offset: true }).nullable().optional(),
  trialEndsAt: z.string().datetime({ offset: true }).nullable().optional(),
  vehicleLimitOverride: z.number().int().min(1).nullable().optional(),
  notes: z.string().max(500).optional(),
});
export type CreateSubscription = z.infer<typeof CreateSubscriptionSchema>;

export const UpdateSubscriptionSchema = CreateSubscriptionSchema.partial();
export type UpdateSubscription = z.infer<typeof UpdateSubscriptionSchema>;
